import styled from '@emotion/styled';
import { mediaQueries, Color } from 'styles/variables';

export const ProductTitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 1rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #e8eaec;
    h2 {
        margin-bottom: 1rem;
    }
    p {
        font-size: 1.4rem;
        margin-bottom: 1rem;
    }

    ${mediaQueries.mediumUp} {
        flex-direction: row;
        justify-content: space-between;
        padding-bottom: 0;
        h2 {
            margin-bottom: 0;
        }
    }
`;

export const SectionWrapper = styled.section`
    display: flex;
    flex-direction: column;
    margin-top: 2rem;
    ${mediaQueries.mediumUp} {
        flex-direction: row;
        justify-content: space-between;
    }
`;

export const ElementContainer = styled.div`
    display: flex;
    flex-direction: column;
    h6 {
        font-size: 1rem;
        letter-spacing: 0.05rem;
        color: ${Color.storm83};
        margin-bottom: 0.4rem;
    }
    .status {
        width: fit-content;
    }
    ${mediaQueries.mediumUp} {
        .statusLabel {
            text-align: center;
        }
    }
`;

export const ActionsElementContainer = styled(ElementContainer)`
    ${mediaQueries.mediumUp} {
        width: 250px;
        text-align: left;
    }

    width: 100%;
    text-align: center;
`;

export const CancellationWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const StatusElementContainer = styled(ElementContainer)`
    flex-direction: row;
`;

export const TooltipWrapper = styled.span`
    margin-top: 2rem;
    margin-left: 0.5rem;
    .status-tooltip {
        cursor: pointer;
    }
`;

export const FooterContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    margin-top: 8rem;
    img {
        margin-bottom: 2rem;
        align-self: center;
        height: 10rem;
        width: 9rem;
    }
    span {
        display: block;
    }
`;

export const ProductPropertiesWrapper = styled.div`
    div + div {
        margin-top: 2rem;
    }
    ${mediaQueries.mediumUp} {
        div + div {
            margin-top: unset;
        }
    }
`;
